import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Formats a phone number to national format
 * @param phoneNumber - The phone number to format
 * @param defaultCountry - The default country code (defaults to 'US')
 * @returns Formatted phone number in national format, or original string if parsing fails
 */
export const formatPhoneNumber = (
    phoneNumber: string | null | undefined,
    defaultCountry: CountryCode = 'US',
): string => {
    if (!phoneNumber) {
        return '';
    }

    const parsedNumber = parsePhoneNumberFromString(
        phoneNumber,
        defaultCountry,
    );

    return parsedNumber?.formatNational() ?? phoneNumber;
};
